import styled from 'styled-components';
import {Select, SelectForwardType} from '@guestapp/old-ui-kit';

export const StyledSelect = styled(Select)`` as SelectForwardType;
